module.exports = __webpack_public_path__ + "static/logo-26877cf7598eb47cc7a04d2b8ac538aa.svg";